import { Link } from "react-router-dom";
import FundsGrid from "../components/FundsGrid.jsx";
import RiskWarning from "../components/RiskWarning.jsx";

const FIRMS = {
  "PwC": "https://www.pwc.lu",
  "Moore": "https://www.moore.ky",
  "EY": "https://www.ey.com",
  "Maples and Calder": "https://maples.com",
  "Maples FS": "https://maples.com",
  "NAV Fund Services": "https://www.navfundservices.com",
  "CIBC": "https://www.cibccaribbean.com",
  "Citibank": "https://www.citigroup.com",
  "HSBC": "https://www.hsbc.com",
  "HDFC": "https://www.hdfcbank.com",
  "ICICI": "https://www.icicibank.com",
  "Vistra": "https://www.vistra.com",
  "KFIN": "https://www.kfintech.com",
};

const FIRM_RE = new RegExp(
  "(" + Object.keys(FIRMS).sort((a, b) => b.length - a.length).join("|") + ")",
  "g"
);

function linkify(text) {
  return String(text).split(FIRM_RE).map((part, i) =>
    FIRMS[part] ? (
      <a key={i} href={FIRMS[part]} target="_blank" rel="noopener noreferrer"
         style={{ color: "var(--gold)", textDecoration: "none", borderBottom: "1px solid rgba(212,175,55,0.4)" }}>
        {part}
      </a>
    ) : (
      part
    )
  );
}

export default function Funds() {
  return (
    <>
      <section className="page-header">
        <div className="wrap">
          <div className="eyebrow">The funds</div>
          <h1>Three vehicles. Three jurisdictions.</h1>
          <p className="sub">
            Capital is deployed through a Cayman-domiciled Emerging and Frontier Markets fund,
            a Luxembourg feeder vehicle, and Daksfirst India Special Situations Fund I.
          </p>
        </div>
      </section>

      <RiskWarning />

      <FundsGrid showHeader={false} />

      <section>
        <div className="wrap">
          <div className="eyebrow">Service providers</div>
          <h2>Independent counterparties</h2>
          <p className="sub" style={{ maxWidth: "62ch" }}>
            Each fund is supported by independent service providers. Listed for
            transparency; inclusion does not imply endorsement.
          </p>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14, marginTop: 16 }}>
              <thead>
                <tr>
                  {["Vehicle", "Auditor", "Administrator", "Legal", "Banker", "Structuring / other"].map((h) => (
                    <th key={h} style={{ padding: "10px 14px", borderBottom: "2px solid rgba(255,255,255,0.18)", textAlign: "left", color: "var(--gold)", fontWeight: 600, whiteSpace: "nowrap" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  ["Cayman EM/FM fund", "Moore", "NAV Fund Services", "Maples and Calder", "CIBC", "-"],
                  ["Luxembourg Securitisation Vehicle", "PwC", "Maples FS", "Maples and Calder", "Citibank", "EY (structuring)"],
                  ["India Special Situations Fund I", "Local statutory auditor", "Daksfirst Advisors Private Limited", "IC Legal", "HDFC / ICICI", "EY (structuring); Vistra (security trustee); KFIN (registrar)"],
                ].map((row) => (
                  <tr key={row[0]}>
                    {row.map((c, i) => (
                      <td key={i} style={{ padding: "10px 14px", borderBottom: "1px solid rgba(255,255,255,0.08)", textAlign: "left", verticalAlign: "top", color: i === 0 ? "#fff" : "inherit", fontWeight: i === 0 ? 600 : 400 }}>{i === 0 ? c : linkify(c)}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap center">
          <p className="muted" style={{ fontSize: 14, maxWidth: "60ch", margin: "0 auto" }}>
            For full fund documentation, performance figures, and AIFM details, please request
            access to the data room.
          </p>
          <Link className="btn btn-primary spacer-m" to="/data-room">Request data room access</Link>
        </div>
      </section>
    </>
  );
}
